// src/pages/Avaliacao/AvaliacaoPage.jsx
import React from 'react';
import AvaliacaoList from '../../components/Avaliacao/AvaliacaoList';
import { Link } from 'react-router-dom';

const AvaliacaoPage = () => {
    return (
        <div>
            <h1>Gestão de Avaliações</h1>
            <Link to="/avaliacoes/registrar">Registrar Nova Avaliação</Link>
            <AvaliacaoList />
        </div>
    );
};

export default AvaliacaoPage;